document.addEventListener('DOMContentLoaded', function () {

    // Quantity js start 
    document.querySelectorAll(".js-button").forEach(function (button) {
        button.addEventListener("click", function () {
            const input = this.parentElement.querySelector("input");
            let val = parseInt(input.value, 10);

            if (this.classList.contains("less")) {
                val = val - 1;
            } else if (this.classList.contains("more")) {
                val = val + 1;
            }

            if (val < 1) {
                val = 1;
            }

            input.value = val;
        });
    });
    // Quantity js end 

    if (document.getElementsByClassName('.scroll-top')) {
        document.querySelectorAll('.scroll-top').forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        });
    }
    Fancybox.bind("[data-fancybox]", {
        mainClass: "dbm-popup-wrapper"
    });

    const toggleBtn = document.querySelector(".js-header-toggle");
    const mobileMenu = document.querySelector(".js-header-menu");
    const body = document.querySelector('body');

    toggleBtn.addEventListener("click", function () {
        body.classList.toggle('is-overlay');
        mobileMenu.classList.toggle("is-open");
        toggleBtn.classList.toggle("is-active");
    });

    const iframeMap = document.querySelector('.dbm-branch-locator__map iframe');
    const defaultMapLink = (window.dbmBranchLocator) ? window.dbmBranchLocator.defaultMapLink : "";

    /* nav megamenu */
    let navAttrLists = document.querySelectorAll("[data-level-id]");
    navAttrLists.forEach(navAttr => {
        navAttr.addEventListener("click", function (e) {
            e.preventDefault();
            let target = e.currentTarget;
            let levelId = target.dataset.levelId;

            let targetMenu = document.querySelector(levelId);
            if (targetMenu) {
                targetMenu.classList.toggle("active");
            }
        });
    });

    // Read Less More toggle 
    const readMoreButton = document.querySelector(".js-read-desc");
    function readMoreLess(event) {
        let description = event.target.closest(".js-description");
        let moreText = description.querySelector(".js-long-detail");
        let dots = description.querySelector(".dots");
        let btnText = event.target;

        if (!moreText) return;
        if (moreText.classList.contains("active")) {
            dots.style.display = "inline";
            btnText.innerHTML = "Read more";
            moreText.classList.remove("active");
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "Read less";
            moreText.classList.add("active");
        }
    }
    readMoreButton?.addEventListener("click", function (event) {
        readMoreLess(event);
    });

    //related products carousel
    const relatedProductscarousel = document.querySelector('.js-related-products');
    if (relatedProductscarousel) {
        const items = relatedProductscarousel.querySelectorAll('.dbm-related-product__item');
        if (items.length > 4 || window.innerWidth <= 768) {
            new Flickity(relatedProductscarousel, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
            });
            
        }
    }

    const frequentlyBoughtTogether = document.querySelector('.js-frequently-bought-together');
    const customPrev = document.querySelector('.js-fbt-prev');
    const customNext = document.querySelector('.js-fbt-next');

    if (frequentlyBoughtTogether) {
        const flkty = new Flickity(frequentlyBoughtTogether, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false
        });

        // Attach custom arrow events
        customPrev?.addEventListener('click', () => flkty.previous());
        customNext?.addEventListener('click', () => flkty.next());
    }

    /* Branch location and delivery postcode scripts starts */
    const LS = localStorage;
    const postcodeKeys = [
        'delivery_postcode',
        'pdp_delivery_postcode',
        'category_delivery_postcode',
        // 'locator_delivery_postcode'
    ];
    const preSelectedPostCode = LS.getItem('deliveryPostcode') || '';
    const preselectedBranch = LS.getItem('selectedBranch') || '';

    let inputs = postcodeKeys.map(name => document.querySelector(`input[name="${name}"]`)).filter(Boolean);
    let branchEls = document.querySelectorAll(`[data-branch][data-postcode]`);
    const announcementSelectedBranchText = document.querySelectorAll(`[data-announcement-branch-text]`);

    const branchLocatorBtns = document.querySelectorAll('.dbm-branch-locator__list-box-btn a');

    // Function to reinitialize inputs and elements after AJAX
    function reinitializePostcodeElements() {
        inputs = postcodeKeys.map(name => document.querySelector(`input[name="${name}"]`)).filter(Boolean);
        branchEls = document.querySelectorAll(`[data-branch][data-postcode]`);
        const preSelectedPostCode = LS.getItem('deliveryPostcode') || '';
        const preselectedBranch = LS.getItem('selectedBranch') || '';
        // Set values
        inputs.forEach(input => input && (input.value = preSelectedPostCode));
        branchEls.forEach(el => {
            if (el.getAttribute('data-branch') === preselectedBranch) {
                el.classList.add('active');   
            }
        });
    }

    // Set initial values and active branch
    reinitializePostcodeElements();
    
    let branchPostCodes = [];
    branchEls.forEach(el => {
        branchPostCodes.push(el.getAttribute('data-postcode'))
    });

    LS.setItem('branchPostCodes', branchPostCodes);
    updateAnnouncementSelectedBranchText();

    // Set initial values and active branch locator page
    
    function updateAnnouncementSelectedBranchText(preselectedBranch = LS.getItem('selectedBranch')) {
        announcementSelectedBranchText.forEach(el => {
            if (preselectedBranch && preselectedBranch.trim() !== '') {
                el.innerHTML = `Store Selected – <span class="underlined-text">${preselectedBranch}</span>`;
            } else {
                el.innerHTML = 'Branch Locator';
            }
        });
    }

    // Utility to show/hide product info/add-to-cart based on postcode/branch
    window.updateProductInfoVisibility = function () {
        const postcode = LS.getItem('deliveryPostcode');
        const branch = LS.getItem('selectedBranch');
        const cartDeliveryPostcode = document.querySelector('.cart-delivery-postcode');
        if (cartDeliveryPostcode) cartDeliveryPostcode.textContent = postcode;
        updateAnnouncementSelectedBranchText(branch);
        const branchPostCodes = LS.getItem('branchPostCodes');

        const requiredSelected = postcode?.trim() &&
            window.branchesPostCodes?.some(branchPostcode => {
                const branchCode = branchPostcode.toLowerCase();
                const code = postcode.trim().toLowerCase();
                return branchCode.includes(code) || code.includes(branchCode);
            });
        
        const requiredSelectedBranch = branch && branch.trim() !== '';
        [
            'product-banner__price-wrap',
            'volume-pricing-note',
            'product-banner__inc-vat-price',
            'product-banner__text-desc',
            'product-form__quantity',
            'product-form',
            'qty',
            'product__pickup-availabilities',
            'pay-less-badge',
            'card-information',
            'card__info',
            'dbm-price__wrapper',
            'dbm-price',
            'dbm-price__unit'
        ].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected ? '' : 'none';
            });
        });

        ['dbm-header__pay']?.forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.visibility = requiredSelected ? '' : 'hidden';
            });
        });
        
        ['enter-delivery-postcode-btn'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected ? 'none' : '';
            });
        });
        ['enter-collection-branch-btn'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelectedBranch ? 'none' : '';
            });
        });
        ['dbm-collection__delivery-options'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected && requiredSelectedBranch ? 'none' : '';
            });
        });
        document.querySelectorAll('.product-banner__price-availability').forEach(el => {
            el.style.display = requiredSelected ? 'none' : '';
        });
        if (document.body.classList.contains('template-product')) {
            loadProductVariantOnSelectedBranch();
        }
        if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
            collectionPriceBasedOnBranch();
        }
    }

    // Reset function for postcode and branch selection
    function resetDeliverySelection() {
        LS.removeItem('deliveryPostcode');
        LS.removeItem('selectedBranch');
        inputs.forEach(input => input && (input.value = ''));
        branchEls.forEach(el => el.classList.remove('active'));
        updateAnnouncementSelectedBranchText();
        updateProductInfoVisibility();
    }

    // Clear cart function on branch change
    document.addEventListener('click', e => {
        const link = e.target.closest("[data-branch][data-postcode]");
        if (!link) return;
        
        e.preventDefault();
        branchEls = document.querySelectorAll("[data-branch][data-postcode]");
        branchEls.forEach(el => el.classList.remove('active'));
        const branch = link.getAttribute('data-branch');
        const postcode = link.getAttribute('data-postcode');

        const previousBranch = LS.getItem('selectedBranch');
        
        if (previousBranch && branch !== previousBranch) {
            // Clear the cart
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                
            }
            )
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        }

        LS.setItem('selectedBranch', branch);
        document.querySelectorAll(`[data-branch="${branch}"][data-postcode]`).forEach(el => el.classList.add('active'));
        inputs.forEach(input => input && (input.value = postcode));
        if (postcode) LS.setItem('deliveryPostcode', postcode);

        let preselectedBranchBtn = document.querySelector(`.dbm-branch-locator__list-box-btn a[data-btn-post-code="${postcode}"]`);
        if (preselectedBranchBtn) {
            preselectedBranchBtn.click();
        }
        updateProductInfoVisibility();
        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }

    });

    // Handle delivery form submit
    postcodeKeys.forEach(name => {
        const form = document.getElementById(name.replace('_postcode', '-form'));
        if (form) {
            form.addEventListener('submit', e => {
                e.preventDefault();
                
                const input = form.querySelector(`input[name="${name}"]`);
                if (input) LS.setItem('deliveryPostcode', input.value);

                if (name.includes('pdp')) {
                    const value = input.value;
                    if (value == "") {
                        resetDeliverySelection();
                    }
                    
                    inputs = Array.from(document.querySelectorAll(postcodeKeys.map(n => `input[name="${n}"]`).join(',')));
                    inputs.forEach(otherInput => otherInput && (otherInput.value = value));
                    LS.setItem('deliveryPostcode', value);
                    if (value != "") {
                        const selectedBranch = window.branches.find(branch =>
                            branch.related_pincodes.some(pincode => {
                                const normalizedPincode = pincode.toLowerCase();
                                const normalizedValue = value.toLowerCase();
                                return normalizedPincode.includes(normalizedValue) ||
                                    normalizedValue.includes(normalizedPincode);
                            })
                        );
                        
                        branchEls.forEach(el => el.classList.remove('active'));
                        if (selectedBranch) {
                            LS.setItem('selectedBranch', selectedBranch ? selectedBranch.title : '');
                            document.querySelectorAll(`[data-branch="${selectedBranch.title}"][data-postcode]`).forEach(el => el.classList.add('active'));
                        }
                    }
                    updateProductInfoVisibility();
                }
                document.querySelector('[data-fancybox-close]')?.click();
                if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
                    window.renderRecentlyViewedCarousel();
                }
            });
        }
    });

    // Use Current Location to get and set postcode
    document.querySelectorAll('.use-current-location').forEach(btn => {
        const buttonTextElement = btn.querySelector('span');
        btn.addEventListener('click', () => {
            resetDeliverySelection();
            if (!navigator.geolocation) return alert('Geolocation is not supported by your browser.');
            btn.disabled = true;
            buttonTextElement.textContent = 'Locating...';
            navigator.geolocation.getCurrentPosition(
                pos => {
                    const { latitude: lat, longitude: lon } = pos.coords;
                    fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`)
                        .then(r => r.json())
                        .then(data => {
                            const pincode = data.address?.postcode || '';
                            inputs.forEach(input => input && (input.value = pincode));
                            LS.setItem('deliveryPostcode', pincode);
                        })
                        .catch(() => alert('Could not fetch pincode.'))
                        .finally(() => {
                            btn.disabled = false;
                            buttonTextElement.textContent = 'Use Current Location';
                            setTimeout(updateProductInfoVisibility, 100);
                        });
                },
                () => {
                    // alert('Unable to retrieve your location.');
                    btn.disabled = false;
                    buttonTextElement.textContent = 'Use Current Location';
                }
            );
        });
    });

    document.addEventListener('input', (e) => {
        const input = e.target;
        if (!input.matches('[name$="_postcode"]')) return;
        
        const name = input.getAttribute('name');
        if (name && postcodeKeys.includes(name) && !name.includes('pdp')) {
            const value = e.target.value;
            if (value == "") {
                resetDeliverySelection();
            }
            
            inputs = Array.from(document.querySelectorAll(postcodeKeys.map(n => `input[name="${n}"]`).join(',')));
            inputs.forEach(otherInput => otherInput && (otherInput.value = value));
            LS.setItem('deliveryPostcode', value);
            if (value != "") {
                const selectedBranch = window.branches.find(branch =>
                    branch.related_pincodes.some(pincode => {
                        const normalizedPincode = pincode.toLowerCase();
                        const normalizedValue = value.toLowerCase();
                        return normalizedPincode.includes(normalizedValue) ||
                            normalizedValue.includes(normalizedPincode);
                    })
                );
                branchEls.forEach(el => el.classList.remove('active'));
                if (selectedBranch) {
                    LS.setItem('selectedBranch', selectedBranch ? selectedBranch.title : '');
                    document.querySelectorAll(`[data-branch="${selectedBranch.title}"][data-postcode]`).forEach(el => el.classList.add('active'));
                }
            }
            updateProductInfoVisibility();
        }
        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }
    });

    document.addEventListener('input', (e) => {
        const input = e.target;
        if (input.matches('[name="pdp_delivery_postcode"]')) return;
    });

    // Branch locator buttons - delegated for AJAX
    document.addEventListener('click', function (event) {
        const btn = event.target.closest('.dbm-branch-locator__list-box-btn a');
        if (!btn) return;
        
        event.preventDefault();
        const branchLocatorBtns = document.querySelectorAll('.dbm-branch-locator__list-box-btn a');
        const isActive = btn.classList.contains('active');
        if (!branchLocatorBtns) return; 
        branchLocatorBtns.forEach((el) => {
            el.classList.remove('active');
            el.textContent = 'Select branch';
        });

        let postCode = btn.getAttribute('data-btn-post-code');
        let branchTitle = btn.getAttribute('data-branch');
        branchEls.forEach(el => el.classList.remove('active'));
        LS.setItem('selectedBranch', branchTitle);
        document.querySelectorAll(`[data-branch="${branchTitle}"][data-postcode]`).forEach(el => el.classList.add('active'));
        inputs.forEach(input => input && (input.value = postCode));
        updateProductInfoVisibility();
        if (postCode) LS.setItem('deliveryPostCode', postCode)
        if (!isActive) {
            btn.classList.add('active');
            btn.textContent = 'Selected';

            const dataLink = btn.getAttribute('data-link');
            if (iframeMap && dataLink) {
                iframeMap.setAttribute('src', dataLink);
            }
        } else {
            if (iframeMap && defaultMapLink) {
                iframeMap.setAttribute('src', defaultMapLink);
            }
        }
        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }
    });

    // Set initial data-original-text attribute - delegated for AJAX
    document.addEventListener('DOMNodeInserted', function() {
        document.querySelectorAll('.dbm-branch-locator__list-box-btn a:not([data-original-text])').forEach(el => {
            el.setAttribute('data-original-text', el.textContent.trim());
        });
    });

    if (branchLocatorBtns) {
        branchLocatorBtns.forEach(el => {
            if (el.getAttribute('data-branch') === preselectedBranch) {
                el.classList.add('active');
                el.textContent = 'Selected';

                const dataLink = el.getAttribute('data-link');
                if (iframeMap && dataLink) {
                    iframeMap.setAttribute('src', dataLink);
                }  else {
                    if (iframeMap && defaultMapLink) {
                        iframeMap.setAttribute('src', defaultMapLink);
                    }
                }
            } else {
                el.textContent = 'Select branch';
            }
        });
    }

    // Expose reinitialize function globally for AJAX callbacks
    window.dbmThemeReinit = function() {
        reinitializePostcodeElements();
        document.querySelectorAll('.dbm-branch-locator__list-box-btn a:not([data-original-text])').forEach(el => {
            el.setAttribute('data-original-text', el.textContent.trim());
        });
        // Reinitialize carousels
        recentProductsCarousel();
        // Reinitialize other dynamic elements
        updateProductInfoVisibility();
    };

    updateProductInfoVisibility();

    /* Branch location and delivery postcode scripts ends */

    /* Preselect branch variant on product page load starts */
    function loadProductVariantOnSelectedBranch() {
        const selectedBranch = LS?.getItem?.('selectedBranch');
        // 
        if (!selectedBranch) return;
        // Find select elements and match by value/text that includes the branch name          
        const selectedVariant = document.querySelector(`input[type="radio"][value="${selectedBranch}"]`);
        if (!selectedVariant) return;
        // 
        selectedVariant.checked = true;
        selectedVariant.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }
    if (document.body.classList.contains('template-product')) {
        loadProductVariantOnSelectedBranch();
    }

    function collectionPriceBasedOnBranch() {
        const selectedBranch = LS?.getItem?.('selectedBranch');
        // 
        if (!selectedBranch) return;

        document.querySelectorAll('.all-variant-prices').forEach(container => {
            const variantPriceEl = container.querySelector(`.variant-price[data-branch-variant="${selectedBranch}"]`);
            if (variantPriceEl) {
                variantPriceEl.style.fontWeight = 'bold';
                // 
                const price = variantPriceEl.innerHTML;
                // 
                // Find the price element in the product card
                const productCard = container.closest(`.card__information`);
                // 
                if (productCard) {
                    const priceEl = productCard.querySelectorAll('.shown-price-amount');
                    const compareAtPriceEl = productCard.querySelectorAll('.shown-compare-at-price-amount');
                    // Update the hidden product form variant ID input
                    const productForm = productCard.querySelector('product-form .product-variant-id');
                    const productVariantId = variantPriceEl.dataset.variantId;
                    // 
                    if (productForm && productVariantId) {
                        productForm.value = productVariantId;
                    }
                    if (!priceEl) return;
                    // 
                    priceEl.forEach(el => {
                        el.innerHTML = price;
                    });

                    if (!compareAtPriceEl) return;
                    const compareAtPrice = variantPriceEl.dataset.variantCompareAtPrice;
                    const compareAtPriceAmount = parseFloat(variantPriceEl.dataset.variantCompareAtPriceAmount);
                    const priceAmount = parseFloat(variantPriceEl.dataset.variantPrice);
                    
                    compareAtPriceEl.forEach(el => {
                        if (el) {
                            if (compareAtPriceAmount && compareAtPriceAmount > 0 && compareAtPriceAmount > priceAmount) {
                                if (el.closest('s').closest('span')) {
                                    el.closest('s').closest('span').style.visibility = 'visible';
                                }
                                el.innerHTML = compareAtPrice;
                                el.style.display = 'block';
                            } else {
                                el.innerHTML = compareAtPrice;
                                el.style.display = 'none';
                                if (el.closest('s').closest('span')) {
                                    el.closest('s').closest('span').style.visibility = 'hidden';
                                }
                            }
                        }
                    });
                    
                    let productAddToCartBtn = productCard.querySelector('product-form .product-form__submit:not(.submit-btn-2)');
                    let productAddToCartBtn2 = productCard.querySelector('product-form .product-form__submit.submit-btn-2');
                    if (!productAddToCartBtn) return;

                    if (variantPriceEl.dataset.variantAvailable === 'true') {
                        productAddToCartBtn.querySelector('span').innerText = window.variantStrings.addToCartDelivery;
                        productAddToCartBtn2.querySelector('span').innerText = window.variantStrings.addToCartCollection;

                        productAddToCartBtn.disabled = false;
                        productAddToCartBtn.classList.remove('disabled');
                        productAddToCartBtn.style.cursor = 'pointer';
                        productAddToCartBtn2.disabled = false;
                        productAddToCartBtn2.classList.remove('disabled');
                        productAddToCartBtn2.style.cursor = 'pointer';
                    } else {
                        productAddToCartBtn.querySelector('span').innerText = window.variantStrings.soldOut;
                        productAddToCartBtn2.querySelector('span').innerText = window.variantStrings.soldOut;
                        productAddToCartBtn.disabled = true;
                        productAddToCartBtn.classList.add('disabled');
                        productAddToCartBtn.style.cursor = 'not-allowed';
                        productAddToCartBtn2.disabled = true;
                        productAddToCartBtn2.classList.add('disabled');
                        productAddToCartBtn2.style.cursor = 'not-allowed';
                    }

                    let skuEl = productCard.querySelector('.product-sku');
                    if (skuEl && variantPriceEl.dataset.sku) {
                        skuEl.textContent = variantPriceEl.dataset.sku;
                    }

                }
            }
        });
    }
    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
        collectionPriceBasedOnBranch();    
    }
    if (document.getElementById("ProductGridContainer")) {
        
        // Observe AJAX product grid updates
        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        const observer = new MutationObserver(function (mutations, observer) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
                        reinitializePostcodeElements();
                        updateProductInfoVisibility();
                    }
                }
            });
        });
        observer.observe(document.getElementById("ProductGridContainer"), {
            childList: true       
        });
    }
});